import { render, staticRenderFns } from "./Support.html?vue&type=template&id=3c7b2cf4&scoped=true&external"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"
import style0 from "./Support.scss?vue&type=style&index=0&id=3c7b2cf4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7b2cf4",
  null
  
)

export default component.exports